export default "__VITE_ASSET__BwPvx33D__"